import axios from "axios";

import { getMappedTransactions } from "../../../helpers/getMappedTransactions";
import { mapMaterialsWithUnits } from "../../../helpers/mapMaterialsWithUnits";

import {
  InvoiceCreateInfo,
  InvoiceItemType,
  InvoiceMaterialRaw,
  RawInvoiceTransaction,
} from "../../../types";

export interface CreateInvoiceInfoParams {
  invoiceTarget: InvoiceItemType;
  transactionNumbers: string[];
}

export const getCreateInvoiceInfo = (params: CreateInvoiceInfoParams) =>
  axios
    .post<InvoiceCreateInfo<RawInvoiceTransaction>>(
      `/invoices/template/rate`,
      params
    )
    .then(({ data }) => {
      const {
        transactions,
        unidentifiedMaterials,
        paymentBalanceAdjustments,
        ...rest
      } = data;

      return {
        ...rest,
        transactions: getMappedTransactions(transactions),
        unidentifiedMaterials: mapMaterialsWithUnits(
          (unidentifiedMaterials as unknown) as InvoiceMaterialRaw[]
        ),
        paymentBalanceAdjustments,
        paymentBalanceAdjustmentsSubTotal: paymentBalanceAdjustments.reduce(
          (sum, balanceAdjustment) => sum + balanceAdjustment.amount,
          0
        ),
      };
    });
